<template>
  <a-card :bordered="false">
    <search-page-view
      :col="3"
      ref="searchPageList"
      :itemNames="['search_orderNo']"
      :button-items="['add_btn']"
      :columns="columns"
      :queryParams="queryParams"
      row-key="id"
      :leftSpace="20"
      requestType="post"
      :requestPromise="loadDataList"
    >
      <a-form-item slot="search_orderNo" label="企业全称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.enterpriseFullName" placeholder="请输入" allowClear></a-input>
      </a-form-item>
      <a-button slot="add_btn" type="primary" icon="plus" @click="onAddEvent" style="margin-left: 12px">新建
      </a-button>
      <template slot="status" slot-scope="rowItem">
        {{ rowItem.record.status == 1 ? '启用' : '禁用' }}
      </template>
      <template slot="discountType" slot-scope="rowItem">
        {{ rowItem.record.discountType == 1 ? '会员卡' : '余额' }}
      </template>
      <span slot="action" slot-scope="rowItem">
        <!--编辑 员工 认证设置 审批设置 组织架构 禁用-->
        <a-space>
           <a @click="onSwitchStatus(rowItem.record)">{{ rowItem.record.status == 1 ? '禁用' : '启用' }}</a>
           <a @click="onDetailsEvent(rowItem.record,0)">查看</a>
           <a v-if="rowItem.record.discountType==2&rowItem.record.proCategory==='2'"
              @click="onDetailsEvent(rowItem.record,1)">编辑</a>
           <a @click="onDiscountUsageRecordEvent(rowItem.record)">使用记录</a>
        </a-space>
      </span>
    </search-page-view>
    <SimpleFormEditorDialog
      v-if="showDialog"
      ref="formEditorDialog"
      @cancel="showDialog=false"
      :title="selectItem&&selectItem.id?(selectItem.isPreView?'查看优惠':'编辑优惠'):'新增优惠'"
      :rules="rules"
      :isPreView="selectItem&&selectItem.isPreView"
      :editConfigList="editConfigList"
      :item="selectItem"
      :width="1200"
      :labelColSpan="4"
      :wrapperColSpan="20"
      @ok="onSubmitEvent"
    >
      <template v-slot:maxUseCount="slotProps">
        <span>
          累计可用订单次数
          <a-input-number
            v-model:value="slotProps.form['maxUseCount']"
            :disabled="slotProps.item.disabled"
            :min="0"
            :max="99"
            :step="1"
            style="width: 80px;"/>
          <span>次(0为不限制次数)，达到次数会员卡强制失效。</span>
        </span>
      </template>
      <template v-slot:leaveAvailableHours="slotProps">
        <span>
          离职后
          <a-input-number
            v-model:value="slotProps.form['leaveAvailableHours']"
            :min="0"
            :max="99"
            :step="1"
            :disabled="slotProps.item.disabled"
            style="width: 80px;"/>
          <span>小时内何用(默认为0即即时失效)</span>
        </span>
      </template>
      <template v-slot:availableGoodsType="slotProps">
        <span>
          <a-radio-group
            v-model:value="slotProps.form['availableGoodsType']"
            :disabled="slotProps.item.disabled">
          <a-radio :value="1">不限制(根据会员卡规则使用)</a-radio>
          <a-radio :value="2">指定商品</a-radio>
          <a-radio :value="3">指定商品分组</a-radio>
        </a-radio-group>
          <template v-if="slotProps.form['availableGoodsType']===2">
           <div v-if="slotProps.form['selectProductList'].length<1" class="select-box">
            <a-select
              v-model:value="slotProps.form['productList']"
              :open="false"
              style="width: 100%"
              :disabled="slotProps.item.disabled"
              placeholder="选择"></a-select>
            <div class="mask-box" @click="toSelectEvent"></div>
          </div>
            <a v-else
               @click="toSelectEvent">{{ slotProps.form['selectProductList'].map(item => item.proName).join(',') }}</a>
          </template>
          <template v-else-if="slotProps.form['availableGoodsType']===3">
            <a-select
              v-model:value="slotProps.form['availableGoodsIds']"
              style="width: 200px"
              :options="proGroupList"
              @change="onGoodsTypeChange"
              :disabled="slotProps.item.disabled"></a-select>
          </template>
        </span>
      </template>
      <template v-slot:maxOrderPerStay="slotProps">
        <span>
          每个入住日期哦最多可订
          <a-input-number
            v-model:value="slotProps.form['maxOrderPerStay']"
            style="width: 60px;display: inline-block"
            :disabled="slotProps.item.disabled"
            :step="1"
            :max="99"
            :min="-1"/>
          间;说明：-1为不限制，若≥1则该员工相应入住日内不可以再次预订酒店。
        </span>
        <br/>
      </template>
    </SimpleFormEditorDialog>
    <!--关联商品-->
    <selected-product-dialog
      :show="showSelectedDialog"
      :width="1200"
      ref="pageList"
      :itemNames="['search_proId','search_proName']"
      :query-params="selectedQueryParams"
      :requestPromise="getModularProductPromise"
      row-key="proId"
      @close="showSelectedDialog=false"
      :columns="getGoodsColumns(true)"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <a-form-item label="商品ID" slot="search_proId" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proId" style="width: 170px" placeholder="请输入商品ID"></a-input>
      </a-form-item>
      <a-form-item label="商品名称" slot="search_proName" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proName" style="width: 170px" placeholder="请输入商品名称"></a-input>
      </a-form-item>
      <template slot="proCatalog" slot-scope="rowItem">
        {{ getProCatalogName(rowItem.record.proCatalog, proCatalogEnum) }}
      </template>
      <div class='footer-btns' slot='footer'>
        <a-space>
          <a-button @click="showSelectedDialog=false">取消</a-button>
          <a-button type="primary" @click="onSelectedResult">确定</a-button>
        </a-space>
      </div>
    </selected-product-dialog>
  </a-card>
</template>
<script>
import searchForm from '@/utils/mixins/searchFormMixins'
import SimpleFormEditorDialog from '@/customComponents/SimpleFormEditorDialog.vue'
import ValidatorHelper from '@/utils/helper/validatorHelper'
import productMixins from '@/utils/mixins/productMixins'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog.vue'

export default {
  name: 'EmployeeBenefit',
  mixins: [searchForm, productMixins],
  components: {
    SelectedProductDialog: SelectedProductDialog,
    SimpleFormEditorDialog: SimpleFormEditorDialog
  },
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      showSelectedDialog: false,
      showDialog: false,
      starRangeList: [],
      selectedQueryParams: {},
      columns: [
        {
          title: '企业ID',
          dataIndex: 'id',
          width: '90px'
        },
        {
          title: '优惠内容',
          dataIndex: 'discountContent',
          width: '320px'
        },

        {
          title: '优惠类型',
          dataIndex: 'discountType',
          scopedSlots: { customRender: 'discountType' },
          width: '120px'
        },
        {
          title: '公司全称',
          dataIndex: 'enterpriseFullName',
          width: '320px'
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: '100px',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '200px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      rules: {
        discountContent: [
          { required: true, message: '请输入优惠内容', trigger: 'change' }
        ],
        enterpriseId: [
          { required: true, message: '请选择关联企业', trigger: 'change' }
        ],
        availableGoodsType: [
          { required: true, message: '请选择可用商品', trigger: 'change' },
          { validator: this.handleProduct }
        ],
        discountType: [
          { required: true, message: '请选择优惠类型', trigger: 'change' }
        ],
        bindType: [
          { required: true, message: '请选择会员卡绑定方式', trigger: 'change' }
        ],
        adminEmail: ValidatorHelper.createEmailRule('请输入管理员邮箱', '管理员邮箱格式有误'),
        adminPhone: ValidatorHelper.createMobileRule(true, '请输入管理员手机号', '手机号码格式有误')
      },
      editConfigList: [
        {
          name: '优惠内容',
          key: 'discountContent',
          placeholder: '请输入优惠内容'
        },
        {
          name: '关联企业名称',
          key: 'enterpriseId',
          placeholder: '请选择企业',
          selectOptions: [],
          disabled: false
        },
        {
          name: '优惠类型',
          radioOptions: [
            {
              value: 1,
              label: '会员卡'
            },
            {
              value: 2,
              label: '余额'
            }
          ],
          key: 'discountType'
        },
        {
          name: '绑定会员卡',
          key: 'membershipCardId',
          placeholder: '请选择会员卡',
          selectOptions: [],
          useFun: function(form) {
            return form.discountType === 1
          }
        },
        {
          name: '使用限制',
          key: 'maxUseCount',
          placeholder: '请输入使用限制',
          slot: true,
          useFun: function(form) {
            return form.discountType === 1
          }
        },
        {
          name: '是否限制本人使用',
          radioOptions: [
            {
              value: 0,
              label: '否'
            },
            {
              value: 1,
              label: '是(通过下单联系人/收件人判断或通过出游人判断[无出游人时使用联系人/收件人判断])'
            }
          ],
          key: 'isSelfUseOnly'// 1是自动充值
        },
        {
          name: '会员卡绑定',
          radioOptions: [
            {
              value: 1,
              label: '认证通过后自动绑定'
            },
            {
              value: 2,
              label: '认证通过后手动绑定'
            }
          ],
          key: 'bindType',
          useFun: function(form) {
            return form.discountType === 1
          }
        },
        {
          name: '离职员工使用',
          key: 'leaveAvailableHours',
          placeholder: '请输入使用限制',
          slot: true,
          useFun: function(form) {
            return form.discountType === 1
          }
        },
        {
          name: '允许批量下单',
          radioOptions: [
            {
              value: 0,
              label: '否'
            },
            {
              value: 1,
              label: '是(允许即可授权认证联系人给其他认证员工，且可使用当前会员卡额度代创建订单，不满足则失败)'
            }
          ],
          key: 'allowBatchOrder',// 1是自动充值
          useFun: function(form) {
            return form.discountType === 1
          }
        },
        {
          name: '可用商品',
          key: 'availableGoodsType',
          slot: true,
          useFun: function(form) {
            return form.discountType === 1
          }
        },
        {
          name: '商品分类',
          key: 'proCategory',
          placeholder: '请输入使用限制',
          type: 'radio',
          radioOptions: [
            {
              value: '2',
              label: '酒店'
            }
          ],
          useFun: function(form) {
            return form.discountType === 2 && form.isSelfUseOnly === 1
          }
        },
        {
          name: '下单限制',
          key: 'maxOrderPerStay',
          type: 'slot',
          useFun: function(form) {
            return form.discountType === 2 && form.isSelfUseOnly === 1 && String(form.proCategory) === '2'
          }
        },
        {
          name: '禁止下单酒店星级/档次',
          key: 'forbiddenHotelLevels',
          type: 'checkbox',
          checkOptions: [],
          useFun: function(form) {
            return form.discountType === 2 && form.isSelfUseOnly === 1 && String(form.proCategory) === '2'
          }
        }
      ],
      queryParams: {},
      selectItem: undefined,
      proGroupList: [],
      selectedRowKeys: [],
      selectedRows: []
    }
  },
  mounted() {
    this.getEnterpriseList()
    this.getMembershipCardList()
    this.getHotelStarList()
    this.getGroupList()
  }
  ,
  activated() {
    this.$refs.searchPageList?.refresh(false)
    this.getEnterpriseList()
    this.getMembershipCardList()
  }
  ,
  methods: {
    handleProduct(rule, value, callback) {
      const availableGoodsType = this.$refs.formEditorDialog?.getFormDataByKey('availableGoodsType')
      const availableGoodsIds = this.$refs.formEditorDialog?.getFormDataByKey('availableGoodsIds')
      const selectProductList = this.$refs.formEditorDialog?.getFormDataByKey('selectProductList')
      if (value) {
        if (String(availableGoodsType) === '2' && (!selectProductList || selectProductList.length < 1)) {
          callback(new Error('请选择商品'))
        } else if (String(availableGoodsType) === '3' && !availableGoodsIds) {
          callback(new Error('请选择商品分组'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    getHotelStarList() {
      const url = 'dict/star/list'
      return this.getHttpServices().getWebDataService().get(url)
        .then(list => {
          if (list && list.length > 0) {
            list.forEach(item => {
              item.code = String(item.code)
            })
          }
          this.starRangeList = list
          this.$set(this.editConfigList[12], 'checkOptions', list.map(item => {
            return {
              value: String(item.code),
              label: item.name
            }
          }))
        })
        .catch(reason => {
          this.showNetWorkErrorMessage(reason)
        })
    },
    getMembershipCardList() {
      const params = { 'limitDto': { 'pageNum': 1, 'pageSize': 1000 } }
      this.getHttpServices().getUserService().post('member/v2/card/getMembershipCardList', params)
        .then(res => {
          const list = res.data?.filter(item => item.cardType === 1 && item.status === 2).map(item => {
            return {
              label: item.name,
              value: item.id
            }
          })
          if (list && list.length > 0) {
            if (list && list.length > 0 && this.editConfigList.length > 1) {
              // 确保属性是响应式的
              this.$set(this.editConfigList[3], 'selectOptions', list)
            }
          }
        }).catch(reason => {
        console.error(reason)
      })
    },
    getGroupList() {
      const requestParams = { 'limitDto': { 'pageNum': 1, 'pageSize': 10000 } }
      this.getHttpServices().getProService().post('proGroup/findProGroupList', requestParams)
        .then(res => {
          //
          this.proGroupList = (res.data || []).map(item => {
            return {
              value: item.groupId,
              label: item.groupName
            }
          })
          //console.error('========res=======',res)
        })
        .catch(reason => {
          console.error(reason)
        })
    },
    getEnterpriseList() {
      const params = { 'limitDto': { 'pageNum': 1, 'pageSize': 1000 } }
      this.getHttpServices().getMemberAuthService().post('member/v3/auth/getEnterpriseList', params)
        .then(res => {
          const list = res.data?.filter(item => item.status === 1).map(item => {
            return {
              label: item.enterpriseFullName,
              value: item.enterpriseId
            }
          })
          if (list && list.length > 0) {
            if (list && list.length > 0 && this.editConfigList.length > 0) {
              // 确保属性是响应式的
              this.$set(this.editConfigList[1], 'selectOptions', list)
            }
          }
        }).catch(reason => {
        console.error(reason)
      })
    },
    onSelectChange(keys, rows) {
      this.selectedRowKeys = keys
      this.selectedRows = rows
    },
    loadDataList(params) {
      return this.getHttpServices().getMemberAuthService().post('employeeDiscount/page', params)
    },
    onDiscountUsageRecordEvent(record) {

      this.openNewPage('MemberCardTransactionDetail', {
        cardId: record.membershipCardId
      })
    },
    onDetailsEvent(item, type) {
      const url = `employeeDiscount/getDetail/${item.id}`
      this.getHttpServices().getMemberAuthService().get(url)
        .then(data => {
          this.editConfigList.forEach(eItem => {
            if (type == 1 && item.proCategory === '2' && (eItem.key === 'forbiddenHotelLevels' || eItem.key === 'maxOrderPerStay')) {
              eItem.disabled = false
            } else {
              eItem.disabled = true
            }
          })
          this.selectItem = {
            ...data,
            isPreView: type === 0,
            forbiddenHotelLevels: data.forbiddenHotelLevels ? data.forbiddenHotelLevels.split(',').map(code => String(code)) : []
          }
          this.showDialog = true
        })
        .catch(err => {
          console.error(err)
          this.$message.error('操作失败，请重试！')
        })
    },
    toSelectEvent() {
      this.showSelectedDialog = true
    },
    onSelectedResult(obj) {
      if (this.selectedRowKeys.length < 1) {
        this.$message.error('请选择产品')
        return false
      }
      this.$refs.formEditorDialog?.updateFormData('selectProductList', this.selectedRows)
      this.showSelectedDialog = false
    },
    onGoodsTypeChange() {
      this.$refs.formEditorDialog?.validateFormData('availableGoodsType')
    },
    onSwitchStatus(item) {
      this.getHttpServices().getMemberAuthService().post(`employeeDiscount/enableStatus/${item.id}`)
        .then(res => {
          this.$refs.searchPageList?.refresh(false)
          this.$message.success('操作成功！')
        })
        .catch(err => {
          console.error(err)
          if (err.msg) {
            this.$message.error(err.msg)
          } else {
            this.$message.error('操作失败，请重试！')
          }
        })
    },

    onAddEvent() {
      // this.openNewPage('EmployeeDiscount')
      this.editConfigList.forEach(item => {
        item.disabled = false
      })
      this.selectItem = {
        maxUseCount: 0,
        leaveAvailableHours: 0,
        isSelfUseOnly: 1,
        discountType: 1,
        maxOrderPerStay: -1,
        bindType: 1,
        availableGoodsType: 1,
        selectProductList: [],
        allowBatchOrder: 0
      }
      this.showDialog = true
    },
    onSubmitEvent(params) {
      const url = params.id ? 'employeeDiscount/update' : 'employeeDiscount/add'
      const data = {
        ...params,
        selectProductList: undefined,
        // availableGoodsIds: params.selectProductList?.map(item => item.proId).join(','),
        forbiddenHotelLevels: params.forbiddenHotelLevels?.join(',')
      }
      if (params.selectProductList && params.selectProductList.length > 0) {
        data.availableGoodsIds = params.selectProductList?.map(item => item.proId).join(',')
        delete data.selectProductList
      }

      this.getHttpServices().getMemberAuthService().post(url, data)
        .then(res => {
          this.showDialog = false
          this.$refs.searchPageList.refresh(!data.id)
          const msg = data.id ? '编辑成功！' : '新增成功！'
          this.$message.success(msg)
          console.error(res)
        })
        .catch(err => {
          console.error(err)
          if (err.msg) {
            this.$message.error(err.msg)
          } else {
            this.$message.error('操作失败，请重试！')
          }
        })
      //console.error('onSubmitEvent', data)
    }
  }
}
</script>


<style scoped lang="less">
.select-box {
  height: 100%;
  margin-left: -10px;
  width: 400px;
  position: relative;
  display: inline-block;

  .mask-box {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: transparent;
  }
}

.footer-btns {
  display: flex;
  justify-content: flex-end;
}

/* 关键样式：让复选框组自动换行且左对齐 */
.custom-checkbox-group {
  display: flex;
  /* 核心：允许换行 */
  flex-wrap: wrap;
  /* 核心：所有行的选项都从左开始排列，不会分散对齐 */
  justify-content: flex-start;
  /* 选项之间的水平和垂直间距，可按需调整 */
  gap: 16px;
  /* 让选项和顶部对齐，避免换行后上下偏移 */
  align-items: center;
}

/* 保证每个选项（复选框+文字）不被拆分 */
.checkbox-item {
  /* 禁止文字在选项内部换行 */
  white-space: nowrap;
  /* 可选：微调选项的上下间距，让换行后更整齐 */
  margin: 4px 0;
}
</style>